"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
setTimeout(function () {
  var accordionItemHeaders = document.querySelectorAll(".accordion-item-header");
  accordionItemHeaders.forEach(function (accordionItemHeader) {
    accordionItemHeader.addEventListener("click", function (event) {
      // Uncomment in case you only want to allow for the display of only one collapsed item at a time!
      var currentlyActiveAccordionItemHeader = document.querySelector(".accordion-item-header.active");
      if (currentlyActiveAccordionItemHeader && currentlyActiveAccordionItemHeader !== accordionItemHeader) {
        currentlyActiveAccordionItemHeader.classList.toggle("active");
        currentlyActiveAccordionItemHeader.nextElementSibling.style.maxHeight = 0;
      }
      accordionItemHeader.classList.toggle("active");
      var accordionItemBody = accordionItemHeader.nextElementSibling;
      if (accordionItemHeader.classList.contains("active")) {
        accordionItemBody.style.maxHeight = accordionItemBody.scrollHeight + "px";
      } else {
        accordionItemBody.style.maxHeight = 0;
      }
      accordionItemHeader.setAttribute("aria-expanded", accordionItemHeader.classList.contains("active"));
    });
  });
}, 0);
document.addEventListener('DOMContentLoaded', function () {
  moveCookieBannerToTop();
  wcagCookieBanner();
  initFocusTrapForCookieBanner();
});
function wcagCookieBanner() {
  setTextForCategoryCheckboxes();
  addAriaHiddenToAllSvgElements();
  removeAriaHiddenFromCookieBanner();
}
function removeAriaHiddenFromCookieBanner() {
  var target = document.querySelector('#s-cnt');
  target.removeAttribute('aria-hidden');
  var originalSetAttribute = target.setAttribute;
  target.setAttribute = function (name, value) {
    var currentValue = this.getAttribute(name);
    if (currentValue == value) return;
    if (name == 'aria-hidden') return;
    originalSetAttribute.call(this, name, value);
  };
}
function addAriaHiddenToAllSvgElements() {
  document.querySelectorAll('#s-inr svg').forEach(function (svg) {
    svg.setAttribute('aria-hidden', 'true');
  });
}
function setTextForCategoryCheckboxes() {
  var categoryCheckboxes = document.querySelectorAll('.titlecategory.b-bn');
  categoryCheckboxes.forEach(function (categoryCheckbox) {
    var categoryCheckboxLabel = categoryCheckbox.querySelector('.expand-button-cfwrapper .sr-only');
    // get text of button with class b-tl
    var categoryButton = categoryCheckbox.querySelector('.b-tl');
    categoryCheckboxLabel.textContent = categoryButton.textContent;
  });
}
function moveCookieBannerToTop() {
  var cookieBanner = document.getElementById('cc--main');
  if (cookieBanner) {
    cookieBanner.classList.add('d-none');
    document.body.insertBefore(cookieBanner, document.body.firstChild);
    cookieBanner.classList.remove('d-none');
  }
}
function initFocusTrapForCookieBanner() {
  // wait 1 second for cookie banner to be rendered
  setTimeout(function () {
    var cookieBannerFocusTrap = setFocusTrapForCookieBanner();
    addFocusTrapOnInit(cookieBannerFocusTrap);
  }, 1000);
}
function addFocusTrapOnInit(cookieBannerFocusTrap) {
  // check if cookie banner is visible
  if (document.querySelector('html').classList.contains('show--settings')) {
    cookieBannerFocusTrap.activate();
  }
}
function setFocusTrapForCookieBanner() {
  // create focus trap
  var cookieBannerFocusTrap = focusTrap.createFocusTrap('#cc--main');

  // remove focus trap on click of multiple close buttons
  document.querySelectorAll('.c-bn').forEach(function (button) {
    button.addEventListener('mousedown', cookieBannerFocusTrap.deactivate);
  });
  return cookieBannerFocusTrap;
}
/* window.addEventListener('load', function () {
    const cookieElement = document.querySelector('#s-cnt');

    const observer = new MutationObserver((mutationsList, observer) => {
        for (const mutation of mutationsList) {
            if (mutation.type === 'childList') {
                console.log('A child node has been added or removed.');
            } else if (mutation.type === 'attributes') {
                console.log(`The ${mutation.attributeName} attribute was modified.`);
            }

            console.log(mutation);

        }
    });

    observer.observe(cookieElement, {
        childList: true, // Observe direct children
        attributes: true, // Observe attribute changes
        subtree: true // Observe changes to all descendants
    });
}); */
window.addEventListener('load', function () {
  var resizeDelay = 240;
  var resizeTimeout;
  window.addEventListener("resize", function () {
    /* update all frame containers and use the same timer */
    document.querySelectorAll('.fb_iframe_widget').forEach(function (iframeContainer) {
      handleResize(iframeContainer);
    });
  });
  function handleResize(iframeContainer) {
    /* debounce update frame with a global timeout */
    try {
      iframeContainer.style.transition = "opacity 0.3s ease-in-out";
      iframeContainer.style.opacity = 0;
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(function () {
        updateIframe(iframeContainer);
      }, resizeDelay);
    } catch (error) {}
  }

  /**
   * @param {HTMLElement} iframeContainer
   */
  function updateIframe(iframeContainer) {
    var spanWrapper = iframeContainer.querySelector('span');
    var iframe = iframeContainer.querySelector('iframe');
    iframeContainer.style.width = '100%';
    spanWrapper.style.width = '100%';
    iframe.style.width = '100%';
    var computedWidth = window.getComputedStyle(spanWrapper).getPropertyValue('width');
    var iframeSrc = iframe.src;
    spanWrapper.style.width = computedWidth;
    var searchParams = new URLSearchParams(iframeSrc.split('?')[1]);

    /* set query width to max parent width */
    searchParams.set('width', Math.trunc(computedWidth.replace('px', '')));

    /* disable adapt to allow the iframe to be bigger than the original one */
    searchParams.set('adapt_container_width', false);
    iframe.src = iframeSrc.split('?')[0] + '?' + searchParams.toString();
    iframe.addEventListener('load', function () {
      iframeContainer.style.opacity = 1;
    }, {
      once: true
    });
  }
});
document.addEventListener('DOMContentLoaded', function (event) {
  if (document.querySelectorAll('.news-list-view.pagination-infinity').length > 0) {
    // for each .news-list-view element, create a new InfiniteScroll instance
    document.querySelectorAll('.news-list-view.pagination-infinity').forEach(function (elem) {
      if (elem.querySelector('.f3-widget-paginator')) {
        var infiniteScrollItem = new InfiniteScroll(elem.querySelector('.row'), {
          history: false,
          path: '#' + elem.id + '.news-list-view .next a',
          append: '#' + elem.id + '.news-list-view .paginateItem',
          // using button, disable loading on scroll
          scrollThreshold: 100,
          status: '#' + elem.id + '.news-list-view .page-load-status',
          hideNav: '#' + elem.id + '.news-list-view .f3-widget-paginator',
          checkLastPage: '#' + elem.id + '.news-list-view .next a'
        });

        // a11y - set focus on the first element of the new page
        // for accessibility reasons
        infiniteScrollItem.on('load', function (body, path, response) {
          // set focus on the first element of the new page
          var lastElement = document.querySelector('#' + elem.id + '.news-list-view .row .paginateItem:last-child a');
          lastElement === null || lastElement === void 0 || lastElement.focus();
        });
      }
    });
  }
});
document.addEventListener('DOMContentLoaded', function () {
  initGLightbox();
});
function initGLightbox() {
  var lightbox = GLightbox({
    touchNavigation: true,
    loop: true,
    keyboardNavigation: true,
    autoplayVideos: true
  });
  localizeGLightbox(lightbox);
  keepFocusOrder(lightbox);
}
function keepFocusOrder(lightbox) {
  var lastFocusedElement = null;
  document.querySelectorAll('.glightbox').forEach(function (item) {
    item.addEventListener('click', function () {
      lastFocusedElement = this;
    });
  });
  lightbox.on('close', function (data) {
    lastFocusedElement.focus();
  });
}
function localizeGLightbox(lightbox) {
  lightbox.on('open', function () {
    if (lightbox.modal) {
      lightbox.modal.setAttribute('aria-label', 'Bildansicht');
      lightbox.modal.querySelector('.gclose').setAttribute('aria-label', 'Schließen');
      lightbox.modal.querySelector('.gnext').setAttribute('aria-label', 'Nächste Folie');
      lightbox.modal.querySelector('.gprev').setAttribute('aria-label', 'Vorherige Folie');
      lightbox.modal.querySelector('.gclose').querySelector('svg').setAttribute('aria-hidden', 'true');
      lightbox.modal.querySelector('.gnext').querySelector('svg').setAttribute('aria-hidden', 'true');
      lightbox.modal.querySelector('.gprev').querySelector('svg').setAttribute('aria-hidden', 'true');
    }
  });
}
document.addEventListener('DOMContentLoaded', function (event) {
  //Dropdown
  var dropdownItems = document.querySelectorAll('.dropdown');
  function findParentByClass(element, className) {
    if (element.classList.contains(className)) return element;
    var parent = element.parentElement;
    if (!parent) return null;
    return findParentByClass(parent, className);
  }
  function menuItemToggle(dropdownItems) {
    if (window.innerWidth >= 768) {
      dropdownItems.forEach(function (dropdownItem) {
        var dropdownToggle = dropdownItem.querySelector('.dropdown-toggle');
        var dropdownMenu = dropdownItem.querySelector('.dropdown-menu');
        var dropdownToggleButton = dropdownItem.querySelector('.nav-dropdown-button');
        var _dropdown_opened_via_keyboard = false;
        dropdownItem.addEventListener('_open-dropdown', function (event) {
          dropdownToggle.classList.add('show');
          dropdownToggle.setAttribute('aria-expanded', 'true');
          dropdownMenu.classList.add('show');
          dropdownToggleButton.querySelector('.visually-hidden.open-text').classList.add('d-none');
          dropdownToggleButton.querySelector('.visually-hidden.closed-text').classList.remove('d-none');
        });
        dropdownItem.addEventListener('_close-dropdown', function (event) {
          event.target.classList.remove('show');
          event.target.setAttribute('aria-expanded', 'false');
          dropdownMenu.classList.remove('show');
          _dropdown_opened_via_keyboard = false;
          dropdownToggleButton.classList.remove('opened-via-keyboard');
          dropdownToggleButton.setAttribute('aria-pressed', 'false');
          dropdownToggleButton.querySelector('.visually-hidden').textContent = 'Subnavigation ausklappen';
          dropdownToggleButton.querySelector('.visually-hidden.open-text').classList.remove('d-none');
          dropdownToggleButton.querySelector('.visually-hidden.closed-text').classList.add('d-none');
        });
        var dropDownItemsArr = Array.from(dropdownMenu.querySelectorAll('a.dropdown-item'));
        dropDownItemsArr.at(-1).addEventListener('focusout', function (event) {
          if (event.relatedTarget != dropDownItemsArr.at(-2)) {
            dropdownItem.dispatchEvent(new Event('_close-dropdown'));
          }
        });
        dropdownToggleButton.addEventListener('focusout', function (event) {
          if (event.relatedTarget == dropdownToggle) {
            dropdownItem.dispatchEvent(new Event('_close-dropdown'));
          }
        });

        /* --- */

        dropdownToggleButton.addEventListener('keydown', function (event) {
          if (event.key != 'Enter' && event.key != ' ') return;
          _dropdown_opened_via_keyboard = true;
          dropdownToggleButton.setAttribute('aria-pressed', 'true');
          dropdownToggleButton.classList.add('opened-via-keyboard');
          var _is_open = dropdownItem.querySelector('.dropdown-menu').classList.contains('show');
          setTimeout(function () {
            dropdownItem.dispatchEvent(new Event(_is_open ? '_close-dropdown' : '_open-dropdown'));
          }, 0);
        });
        dropdownItem.addEventListener('mouseover', function (event) {
          dropdownItem.dispatchEvent(new Event('_open-dropdown'));
          if (dropdownItem.timeout) clearTimeout(dropdownItem.timeout);
        });
        dropdownItem.addEventListener('mouseout', function (event) {
          dropdownItem.timeout = setTimeout(function () {
            if (_dropdown_opened_via_keyboard) return;
            dropdownItem.dispatchEvent(new Event('_close-dropdown'));
          }, 100);
        });
        document.body.addEventListener('click', function (event) {
          if (!findParentByClass(event.target, 'navbar-nav')) {
            document.querySelectorAll('.dropdown').forEach(function (dropdownItem) {
              dropdownItem.dispatchEvent(new Event('_close-dropdown'));
            });
          }
        });
      });
    } else {
      dropdownItems.forEach(function (dropdownItem) {
        var dropdownToggle = dropdownItem.querySelector('.dropdown-toggle');
        var dropdownMenu = dropdownItem.querySelector('.dropdown-menu');
        dropdownToggle.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          dropdownToggle.classList.toggle('show');
          dropdownMenu.classList.toggle('show');
          if (dropdownToggle.getAttribute('aria-expanded') === 'true') {
            dropdownToggle.setAttribute('aria-expanded', 'false');
          } else {
            dropdownToggle.setAttribute('aria-expanded', 'true');
          }
        });
      });
    }
  }
  menuItemToggle(dropdownItems);
  initDesktopNavigation(dropdownItems);

  //Mobile Nav Toggler
  var mainNav = document.getElementById('navbarNavDropdown');
  var navToggle = document.getElementsByClassName('navbar-toggler');
  function mainNavToggle() {
    mainNav.classList.toggle('collapsed');
    navToggle[0].classList.toggle('clicked');
    if (navToggle[0].getAttribute('aria-expanded') === 'true') {
      navToggle[0].setAttribute('aria-expanded', 'false');
    } else {
      navToggle[0].setAttribute('aria-expanded', 'true');
    }
  }
  navToggle[0].addEventListener('click', mainNavToggle);
  document.querySelectorAll('.shortcut').forEach(function (shortcutItem) {
    shortcutItem.addEventListener('click', function (event) {
      event.preventDefault();
    });
  });
});
function initDesktopNavigation(dropdownItems) {
  if (window.innerWidth >= 992) {
    dropdownItems.forEach(function (dropdownItem) {
      var dropdownToggle = dropdownItem.querySelector('.dropdown-toggle');
      var dropdownMenu = dropdownItem.querySelector('.dropdown-menu');
      dropdownToggle.classList.remove('show');
      dropdownToggle.setAttribute('aria-expanded', 'false');
      dropdownMenu.classList.remove('show');
      dropdownMenu.style.display = '';
    });
  }
}
function initMobileNavigation(dropdownItems) {
  if (window.innerWidth < 992) {
    dropdownItems.forEach(function (dropdownItem) {
      var dropdownToggle = dropdownItem.querySelector('.dropdown-menu.active .dropdown-toggle');
      var dropdownMenu = dropdownItem.querySelector('.dropdown-menu.active .dropdown-menu');
      dropdownToggle === null || dropdownToggle === void 0 || dropdownToggle.classList.add('show');
      dropdownToggle === null || dropdownToggle === void 0 || dropdownToggle.setAttribute('aria-expanded', 'true');
      dropdownMenu === null || dropdownMenu === void 0 || dropdownMenu.classList.add('show');
    });
  }
}

// resize window
window.addEventListener('resize', function (event) {
  //Dropdown
  var dropdownItems = document.querySelectorAll('.dropdown');
  initDesktopNavigation(dropdownItems);
  initMobileNavigation(dropdownItems);
});
function news_link_listener_page() {
  document.querySelectorAll('div.row.article , .col-12.article.paginateItem').forEach(function (elem) {
    var linkElem = elem.querySelector('a[href]');
    if (linkElem) {
      elem.addEventListener('click', function (ev) {
        window.location.href = linkElem.href;
      });
    }
  });
}
document.addEventListener('DOMContentLoaded', function (event) {
  news_link_listener_page();
});
document.querySelectorAll('.wpIframe-show-after-load').forEach(function (iframe) {
  iframe.addEventListener('load', function () {
    iframe.style.opacity = 1;
  });
});
var setEqualHeightForShuffleItems = function setEqualHeightForShuffleItems(childItemSelector) {
  //selects all items
  var elements = _toConsumableArray(childItemSelector.querySelectorAll('.wpTeamMember:not(.wpTeamMemberRow)'));
  //reset heights
  elements.forEach(function (item, index) {
    item.style.height = "auto";
  });
  //puts the height of all items in an array
  var heights = [];
  elements.forEach(function (item, index) {
    heights[index] = item.offsetHeight;
  });
  //gets the highest value out of the array
  var maxHeight = Math.max.apply(Math, heights);
  elements.forEach(function (item, index) {
    item.style.height = maxHeight + "px";
  });
};
document.addEventListener('DOMContentLoaded', function (event) {
  if (document.getElementsByClassName('wpContentTeam').length > 0) {
    document.querySelectorAll('.wpContentTeam').forEach(function (item) {
      var element = item.querySelector('.shuffle-container');
      if (element) {
        // set equalHeights for all shuffle items
        setEqualHeightForShuffleItems(element);
        var Shuffle = window.Shuffle;
        var shuffleInstance = new Shuffle(element, {
          itemSelector: '.wpTeamMember',
          buffer: 10
        });

        // sets the apsect ratio for the placeholder images checking the aspect ratio of the first image
        setPlaceholderImageAspectRatio(element);
        item.querySelectorAll('.filter-button').forEach(function (filterBtn) {
          filterBtn.addEventListener('click', function (event) {
            shuffleInstance.filter(event.target.getAttribute('data-filter'));
            var _iterator = _createForOfIteratorHelper(event.target.parentNode.children),
              _step;
            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                var sibling = _step.value;
                if (sibling !== event.target.parentNode) {
                  sibling.classList.remove('active');
                }
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }
            event.target.classList.remove('active');
            event.target.classList.add('active');
            var visibleItems = 0;
            // count how many shuffleInstance.items are visible
            shuffleInstance.items.forEach(function (item) {
              if (item.isVisible) {
                visibleItems++;
              }
            });
            var ariaLive = document.getElementById(filterBtn.getAttribute('aria-controls'));
            ariaLive.innerText = ' Aktuell gefiltert nach ' + filterBtn.innerText + '. ' + visibleItems + '  Feuerwehrmitglieder werden angezeigt.';
          });
        });
      }
    });
  }
});

// sets the apsect ratio for the placeholder images checking the aspect ratio of the first image
function setPlaceholderImageAspectRatio(element) {
  if (!element) return;

  // get the images with the placeholder class
  var placeholderImages = element.querySelectorAll('.placeholder-image');

  // get the aspect ratio of the first image
  var firstElement = element.querySelector('.member-image');
  if (!firstElement) return;
  var aspectRatio = element.querySelector('.member-image').width / element.querySelector('.member-image').height;

  // set the aspect ratio of the images
  placeholderImages.forEach(function (image) {
    image.classList.add('object-cover');
    image.style.aspectRatio = aspectRatio;
  });
}
window.addEventListener('resize', function () {
  if (document.getElementsByClassName('wpContentTeam').length > 0) {
    document.querySelectorAll('.wpContentTeam').forEach(function (item) {
      var element = item.querySelector('.shuffle-container');
      if (element) {
        // set equalHeights for all shuffle items
        setEqualHeightForShuffleItems(element);
      }
    });
  }
});
document.addEventListener('DOMContentLoaded', function (event) {
  var _OverlayScrollbarsGlo = OverlayScrollbarsGlobal,
    OverlayScrollbars = _OverlayScrollbarsGlo.OverlayScrollbars,
    ScrollbarsHidingPlugin = _OverlayScrollbarsGlo.ScrollbarsHidingPlugin,
    SizeObserverPlugin = _OverlayScrollbarsGlo.SizeObserverPlugin,
    ClickScrollPlugin = _OverlayScrollbarsGlo.ClickScrollPlugin;
  OverlayScrollbars.plugin(ClickScrollPlugin);
  document.querySelectorAll('figure.table').forEach(function (table) {
    var osInstance = OverlayScrollbars(table, {
      scrollbars: {
        clickScroll: true,
        dragScroll: true
      }
    });
  });
});
document.addEventListener('DOMContentLoaded', function (event) {
  function initAcc(elem, option) {
    //addEventListener on mouse click
    document.addEventListener('click', function (e) {
      //check is the right element clicked
      if (!e.target.matches(elem + ' .a-btn')) return;else {
        //check if element contains active class
        if (!e.target.parentElement.classList.contains('active')) {
          if (option == true) {
            //if option true remove active class from all other accordions
            var elementList = document.querySelectorAll(elem + ' .a-container');
            Array.prototype.forEach.call(elementList, function (e) {
              e.classList.remove('active');
            });
          }
          //add active class on cliked accordion
          e.target.parentElement.classList.add('active');
        } else {
          //remove active class on cliked accordion
          e.target.parentElement.classList.remove('active');
        }
      }
    });
  }

  //activate accordion function
  initAcc('.accordion', true);
});
document.addEventListener('DOMContentLoaded', function () {
  // tooltip functionality
  // 1. place the tooltip wrapper element around
  // 2. set the tooltip with the role="tooltip" attribute inside
  // 3. add the class "tooltip-focus" to the element that should show the tooltip on focus

  document.querySelectorAll('.tooltip-wrapper').forEach(function (wrapper) {
    var tooltip = wrapper.querySelector("[role='tooltip']");
    if (!tooltip) return;
    var focusableElements = wrapper.querySelectorAll('.tooltip-trigger, [role="tooltip"]');

    // Show tooltip on mouse enter
    wrapper.addEventListener('mouseenter', function () {
      tooltip.classList.remove('visually-hidden');
    });

    // Hide tooltip on mouse leave
    wrapper.addEventListener('mouseleave', function () {
      tooltip.classList.add('visually-hidden');
    });

    // Show tooltip on focus within the wrapper
    wrapper.addEventListener('focusin', function () {
      tooltip.classList.remove('visually-hidden');
    });

    // Hide tooltip when focus leaves the wrapper
    wrapper.addEventListener('focusout', function (event) {
      // Ensure the newly focused element is outside the tooltip wrapper
      if (!_toConsumableArray(focusableElements).includes(event.relatedTarget)) {
        tooltip.classList.add('visually-hidden');
      }
    });
  });

  // press esc to close all tooltips
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      // do something
      // check if any tooltip is active
      document.querySelectorAll('.tooltip').forEach(function (tooltip) {
        tooltip.classList.add('visually-hidden');
      });
    }
  });
});

// @ts-check
var colors = {
  green: '#7FC473',
  red: '#e36b6b',
  orange: '#FFA500',
  yellow: '#B88E0D'
};
window.addEventListener("load", function () {
  document.querySelectorAll(".wastl-js-target").forEach(function (traget) {
    /*
        ? fetch data via ajax and init map
        ! if fetch fails use the data provided in the data attributes
    */

    fetch('?type=1116789&bezirk=' + traget.dataset.bezirk).then(function (response) {
      if (response.ok) return response.json();
      throw new Error("Network response was not ok.");
    }).then(function (res) {
      init(traget.id, res.data, res.path);
    }).catch(function () {
      return init(traget.id, traget.dataset.xml, traget.dataset.path);
    });
  });
  function init(id, data, localPath) {
    "use strict";

    var _XMLParser$parse;
    var resp = (_XMLParser$parse = new XMLParser().parse(data)) === null || _XMLParser$parse === void 0 ? void 0 : _XMLParser$parse.root;
    if (!resp || resp.length == 0) throw new Error("Invalid XML response");
    var map = document.getElementById(id);
    if (!map) throw new Error("Map with id ".concat(id, " not found"));
    if (map.getAttribute("data-bezirk") != "none") {
      renderStaticImageContent(resp, map, id, localPath);
    } else {
      renderSVGConten(resp, map, id);
    }

    /** @type {HTMLElement|null} */
    var placeholder = map.querySelector('.placeholder');
    placeholder === null || placeholder === void 0 || placeholder.style.setProperty("opacity", "0");
    setTimeout(function () {
      return placeholder === null || placeholder === void 0 ? void 0 : placeholder.remove();
    }, 1000);

    /** @type {HTMLElement|null} */
    var spinner = map.querySelector(".loading-spinner");
    spinner === null || spinner === void 0 || spinner.style.setProperty("opacity", "0");
    setTimeout(function () {
      return spinner === null || spinner === void 0 ? void 0 : spinner.remove();
    }, 1000);
  }
  function renderStaticImageContent(resp, map, id, localPath) {
    var _resp$cOptionen;
    var image = map.querySelector("img#".concat(id, "-image"));
    if (!image) throw new Error("Image with id ".concat(id, "-image not found"));
    image.src = "".concat(localPath, "/").concat(resp === null || resp === void 0 || (_resp$cOptionen = resp.cOptionen) === null || _resp$cOptionen === void 0 ? void 0 : _resp$cOptionen.cBackground.split("/").pop());
    var dots = document.createElement("div");
    dots.classList.add("dots");
    map.appendChild(dots);
    var _iterator2 = _createForOfIteratorHelper(resp === null || resp === void 0 ? void 0 : resp.aFFNr),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var data = _step2.value;
        var dot = document.createElement("div");
        dot.classList.add("dot");
        dot.id = data === null || data === void 0 ? void 0 : data.FFNr;
        dot.style.top = "".concat((data === null || data === void 0 ? void 0 : data.PixelOben) / 424 * 100, "%");
        dot.style.left = "".concat((data === null || data === void 0 ? void 0 : data.PixelRechts) / 500 * 100, "%");
        if (data !== null && data !== void 0 && data.Button) {
          var _resp$cOptionen2;
          dot.style.backgroundImage = "url(".concat(localPath || (resp === null || resp === void 0 || (_resp$cOptionen2 = resp.cOptionen) === null || _resp$cOptionen2 === void 0 ? void 0 : _resp$cOptionen2.cButP), "/").concat(data === null || data === void 0 ? void 0 : data.Button, ")");
        }
        dots.appendChild(dot);
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
    var coords = {
      1000: {
        left: 217,
        top: 155
      },
      1001: {
        left: 219,
        top: 209
      },
      1002: {
        left: 327,
        top: 244
      },
      1013: {
        left: 334,
        top: 197
      },
      1003: {
        left: 374,
        top: 121
      },
      1004: {
        left: 378,
        top: 228
      },
      1005: {
        left: 296,
        top: 326
      },
      1006: {
        left: 94,
        top: 226
      },
      1007: {
        left: 321,
        top: 261
      },
      1008: {
        left: 410,
        top: 257
      },
      1015: {
        left: 171,
        top: 203
      },
      1019: {
        left: 317,
        top: 310
      },
      1020: {
        left: 144,
        top: 108
      },
      1021: {
        left: 313,
        top: 213
      },
      1023: {
        left: 291,
        top: 183
      },
      1026: {
        left: 318,
        top: 182
      },
      1027: {
        left: 163,
        top: 59
      },
      1028: {
        left: 280,
        top: 169
      },
      1010: {
        left: 117,
        top: 66
      },
      1012: {
        left: 225,
        top: 96
      },
      1011: {
        left: 296,
        top: 122
      },
      1014: {
        left: 215,
        top: 252
      }
    };
    var actives = document.getElementById("actives");
    var _iterator3 = _createForOfIteratorHelper(resp === null || resp === void 0 ? void 0 : resp.aBAZID),
      _step3;
    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var _data = _step3.value;
        if (_data !== null && _data !== void 0 && _data.nLayer && (_data === null || _data === void 0 ? void 0 : _data.nLayer) !== " ") {
          var _resp$cOptionen3;
          var img = document.createElement("img");
          img.src = "".concat(localPath || (resp === null || resp === void 0 || (_resp$cOptionen3 = resp.cOptionen) === null || _resp$cOptionen3 === void 0 ? void 0 : _resp$cOptionen3.cLayP), "/").concat(_data === null || _data === void 0 ? void 0 : _data.nLayer);
          actives.appendChild(img);
        }
        var _dot = document.createElement("div");
        _dot.classList.add("dot");
        _dot.id = _data === null || _data === void 0 ? void 0 : _data.nBAZID;
        if (_data !== null && _data !== void 0 && _data.nBAZID && coords[_data === null || _data === void 0 ? void 0 : _data.nBAZID]) {
          // Hintergrundbilder sind immer 500x424
          _dot.style.top = "".concat(coords[_data === null || _data === void 0 ? void 0 : _data.nBAZID].top / 424 * 100, "%");
          _dot.style.left = "".concat(coords[_data === null || _data === void 0 ? void 0 : _data.nBAZID].left / 500 * 100, "%");
        }
        if (_data !== null && _data !== void 0 && _data.nBAZStatus) {
          var _resp$cOptionen4;
          _dot.style.backgroundImage = "url(".concat(localPath || (resp === null || resp === void 0 || (_resp$cOptionen4 = resp.cOptionen) === null || _resp$cOptionen4 === void 0 ? void 0 : _resp$cOptionen4.cButP), "/").concat(_data === null || _data === void 0 ? void 0 : _data.nBAZStatus, ")");
        }
        dots.appendChild(_dot);
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
  }
  function renderSVGConten(resp, map) {
    var svg = map.querySelector("svg");
    var mappingArray = [];
    function getHexColorFromFileName(name) {
      name = name.toLowerCase();
      switch (true) {
        case name.includes('grün'):
          return colors.green;
        case name.includes('rot'):
          return colors.red;
        case name.includes('orange'):
          return colors.orange;
        case name.includes('gelb'):
          return colors.yellow;
      }
      return false;
    }
    var _iterator4 = _createForOfIteratorHelper(resp === null || resp === void 0 ? void 0 : resp.aBAZID),
      _step4;
    try {
      for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
        var data = _step4.value;
        mappingArray.push({
          name: data.cFriendlyName,
          status: data.nBAZStatus,
          image: data.nLayer,
          id: data.nBAZID,
          incidents: data.CountEinsatz,
          stations: data.CountFeuerwehr,
          mappingData: {
            svgContenName: data.cFriendlyName.replace('BAZ ', '').replace('AAZ ', '').trim(),
            tooltipName: data.cFriendlyName.trim(),
            fillColor: getHexColorFromFileName(data.nLayer),
            fillColorName: data.nLayer
          }
        });
      }
    } catch (err) {
      _iterator4.e(err);
    } finally {
      _iterator4.f();
    }
    var activeStationsList = map.parentElement.querySelector(".activeStations ul");
    var stationsInMission = false;
    mappingArray.forEach(function (data) {
      var element = svg.querySelector('[inkscape\\:label="' + data.mappingData.svgContenName + '"]');
      if (!element) return;
      if (data.stations === 1) {
        var station = document.createElement('li');
        station.textContent = 'Im Bezirk ' + data.mappingData.svgContenName + ' ist eine Feuerwehr im Einsatz';
        activeStationsList.appendChild(station);
        stationsInMission = true;
      } else if (data.stations > 1) {
        var _station = document.createElement('li');
        _station.textContent = 'Im Bezirk ' + data.mappingData.svgContenName + ' sind ' + data.stations + ' Feuerwehren im Einsatz';
        activeStationsList.appendChild(_station);
        stationsInMission = true;
      }
      element.addEventListener('mousemove', function (evt) {
        var tooltip = document.querySelector('#wastl-tooltip');
        if (!tooltip) {
          tooltip = document.createElement('div');
          tooltip.id = 'wastl-tooltip';
          tooltip.setAttribute('role', 'tooltip');
          document.body.appendChild(tooltip);
        }
        element.setAttribute('aria-describedby', 'wastl-tooltip');
        tooltip.innerHTML = /* HTML */"\n                    <div class=\"t-heading\">\n                        <span>".concat(data.mappingData.tooltipName, "</span>\n                    </div>\n                    <div class=\"t-line\">\n                        <div>Feuerwehren im Einsatz:</div>\n                        <div class=\"t-line-val\">").concat(data.stations, "</div>\n                    </div>\n                ");
        tooltip.style.left = evt.pageX + 10 + 'px';
        tooltip.style.top = evt.pageY - 50 + 'px';
      });
      element.addEventListener('mouseout', function () {
        var _document$querySelect;
        (_document$querySelect = document.querySelector('#wastl-tooltip')) === null || _document$querySelect === void 0 || _document$querySelect.remove();
        element.removeAttribute('aria-describedby');
      });
      var color = data.mappingData.fillColor;
      if (color) {
        var fill = color;
        switch (color) {
          case colors.yellow:
            fill = "url(#striped-yellow)";
            break;
          case colors.red:
            fill = "url(#striped-red)";
            break;
          case colors.green:
            fill = color;
            break;
        }
        element.style.fill = fill;
        element.querySelectorAll('*').forEach(function (child) {
          child.style.fill = fill;
        });
      }
    });
    if (!stationsInMission) {
      var activeStations = map.parentElement.querySelector(".activeStations");
      // remove all content in activeStations
      activeStations.innerHTML = '';
      var text = document.createElement('h4');
      text.textContent = 'Es sind keine Feuerwehren im Einsatz!';
      activeStations.appendChild(text);
    }
  }
});
// @ts-check

window.addEventListener('load', function () {
  // loop over all elements with the class weather-warnings-js-target
  var widgets = document.querySelectorAll('.weather-warnings-js-target');
  widgets.forEach(function (widget) {
    // get emma id
    var emmaId = widget.getAttribute('data-emma-id');
    // fetch the data, which is html content, and add it to the target element
    fetch("?type=916105&emmaId=".concat(emmaId)).then(function (response) {
      if (response.ok) return response.text();
      throw new Error('Network response was not ok.');
    }).then(function (res) {
      widget.outerHTML = res;
      globalThis.initWeatherWarnings();
    });
  });
});
window.addEventListener("load", function () {
  document.querySelectorAll(".tx-wp-donation").forEach(function (element) {
    WpFormHandler.initOnContainer(element);
  });
});
window.addEventListener("load", function () {
  document.querySelectorAll(".tx-wp-forms").forEach(function (element) {
    WpFormHandler.initOnContainer(element);
    element.querySelectorAll('.fieldwrap.form-group:has(select.form-control)').forEach(function (fieldWrap) {
      setInterval(function () {
        var _fieldWrap$querySelec;
        (_fieldWrap$querySelec = fieldWrap.querySelector('label')) === null || _fieldWrap$querySelec === void 0 || _fieldWrap$querySelec.classList.add('animated-label-up');
      }, 10);
    });
  });
});
// @ts-check
var WpOrder = /*#__PURE__*/function () {
  function WpOrder() {
    _classCallCheck(this, WpOrder);
  }
  return _createClass(WpOrder, [{
    key: "_findParentByClass",
    value:
    /**
     * @param {HTMLElement} element
     * @param {string} className
     * @returns {HTMLElement|null}
     */
    function _findParentByClass(element, className) {
      if (element.classList.contains(className)) return element;
      var parent = element.parentElement;
      if (!parent) return null;
      return this._findParentByClass(parent, className);
    }

    /**
     * @param {HTMLElement} element
     * @returns {HTMLInputElement}
     */
  }, {
    key: "_findNumberContainerInput",
    value: function _findNumberContainerInput(element) {
      var container = this._findParentByClass(element, "number-container");
      if (!container) {
        throw new Error("numberContainerPlus: number-container not found");
      }
      var input = container.querySelector(".quantity-input");
      if (!(input instanceof HTMLInputElement)) {
        throw new Error("numberContainerPlus: quantity-input not instance of HTMLInputElement");
      }
      return input;
    }

    /**
     * @param {HTMLElement} element
     */
  }, {
    key: "numberContainerPlus",
    value: function numberContainerPlus(element) {
      var input = this._findNumberContainerInput(element);
      var currentValue = parseInt(input.value);
      input.value = String(currentValue + 1);
      input.dispatchEvent(new Event("change"));
      input.dispatchEvent(new Event("keyup"));
    }

    /**
     * @param {HTMLElement} element
     */
  }, {
    key: "numberContainerMinus",
    value: function numberContainerMinus(element) {
      var input = this._findNumberContainerInput(element);
      var currentValue = parseInt(input.value);
      if (currentValue == 0) return;
      input.value = String(currentValue - 1);
      input.dispatchEvent(new Event("change"));
      input.dispatchEvent(new Event("keyup"));
    }

    /**
     * @param {Element|HTMLElement} container
     */
  }, {
    key: "productContainerEventListener",
    value: function productContainerEventListener(container) {
      var _this = this;
      container.querySelectorAll('.product-element').forEach(function (element) {
        _this._customProductCountValidation(element);

        // TODO: limit to elements
        element.addEventListener('click', function () {
          _this._updateSubmitBtnPrice(container);
        });
        element.querySelectorAll('input').forEach(function (formElement) {
          formElement.addEventListener('keyup', function () {
            _this._updateSubmitBtnPrice(container);
          });
          formElement.addEventListener('blur', function () {
            _this._updateSubmitBtnPrice(container);
          });
        });
      });
      this._updateSubmitBtnPrice(container);
    }

    /**
     * @param {Element|HTMLElement} container
     */
  }, {
    key: "_customProductCountValidation",
    value: function _customProductCountValidation(container) {
      var _numberInput$getAttri, _numberInput$getAttri2;
      /** @type {HTMLInputElement|null} */
      var numberInput = container.querySelector('.product-quantity .number-container input.quantity-input');
      if (!numberInput) return;
      var min = parseInt((_numberInput$getAttri = numberInput.getAttribute('data-min')) !== null && _numberInput$getAttri !== void 0 ? _numberInput$getAttri : '0');
      var max = parseInt((_numberInput$getAttri2 = numberInput.getAttribute('data-max')) !== null && _numberInput$getAttri2 !== void 0 ? _numberInput$getAttri2 : '0');
      if (max === 0) max = 99999;

      /** @type {HTMLButtonElement|null} */
      var plusButton = container.querySelector('.product-quantity .plus-minus-container button.plus-button');

      /** @type {HTMLButtonElement|null} */
      var minusButton = container.querySelector('.product-quantity .plus-minus-container button.minus-button');
      var checkMinMax = function checkMinMax() {
        var value = parseInt(numberInput.value);
        var updateBasedOnMinMax = function updateBasedOnMinMax() {
          if (value < min) numberInput.value = String(min);
          if (value > max) numberInput.value = String(max);
        };
        var setDisabledOnBtnIfMinMax = function setDisabledOnBtnIfMinMax() {
          if (plusButton) plusButton.removeAttribute('disabled');
          if (minusButton) minusButton.removeAttribute('disabled');
          if (value <= min) {
            if (minusButton) minusButton.setAttribute('disabled', 'disabled');
          }
          ;
          if (value >= max) {
            if (plusButton) plusButton.setAttribute('disabled', 'disabled');
          }
          ;
        };
        updateBasedOnMinMax();
        setDisabledOnBtnIfMinMax();
      };
      numberInput.addEventListener('change', function () {
        checkMinMax();
      });
      checkMinMax();
    }

    /**
     * @param {Element|HTMLElement} container
     */
  }, {
    key: "_updateSubmitBtnPrice",
    value: function _updateSubmitBtnPrice(container) {
      /** @type {number} (float) */
      var sum = 0;
      container.querySelectorAll('[data-product-price-number]').forEach(function (element) {
        var pricePerItem = element.getAttribute('data-product-price-number');

        /** @type {HTMLInputElement|null} */
        var input = element.querySelector('input.quantity-input');
        if (input && parseInt(input.value) > 0) {
          sum += parseInt(input.value) * parseFloat(pricePerItem !== null && pricePerItem !== void 0 ? pricePerItem : '0');
        }
      });
      container.querySelectorAll('[data-product-price-checkbox]').forEach(function (element) {
        var pricePerItem = element.getAttribute('data-product-price-checkbox');

        /** @type {HTMLInputElement|null} */
        var checkbox = element.querySelector('input[type=checkbox]');
        if (checkbox && checkbox.checked) {
          sum += parseFloat(pricePerItem !== null && pricePerItem !== void 0 ? pricePerItem : '0');
        }
      });
      container.querySelectorAll('[data-product-price-required]').forEach(function (element) {
        var pricePerItem = element.getAttribute('data-product-price-required');
        sum += parseFloat(pricePerItem !== null && pricePerItem !== void 0 ? pricePerItem : '0');
      });
      document.querySelectorAll('[data-price-target-inner]').forEach(function (element) {
        if (sum > 0) {
          element.innerHTML = " für " + sum.toFixed(2) + " €";
        } else {
          element.innerHTML = "";
        }
      });
    }

    /**
     * @param {Element|HTMLElement} container
     */
  }, {
    key: "_updateSubmitBtnPriceOverview",
    value: function _updateSubmitBtnPriceOverview(container) {
      /** @type {number} (float) */
      var sum = 0;
      container.querySelectorAll('[data-product-price-number]').forEach(function (element) {
        var pricePerItem = element.getAttribute('data-product-price-number');
        var quantity = element.getAttribute('data-product-quantity');
        sum += parseFloat(quantity !== null && quantity !== void 0 ? quantity : '0') * parseFloat(pricePerItem !== null && pricePerItem !== void 0 ? pricePerItem : '0');
      });
      document.querySelectorAll('[data-price-target-inner]').forEach(function (element) {
        if (sum > 0) {
          element.innerHTML = " für " + sum.toFixed(2) + " €";
        } else {
          element.innerHTML = "";
        }
      });
    }
  }]);
}();
globalThis.WpOrderUtils = new WpOrder();
window.addEventListener("load", function () {
  document.querySelectorAll(".tx-wp-order").forEach(function (element) {
    if (element.querySelectorAll('form').length === 0) return;
    WpOrderUtils.productContainerEventListener(element);
    WpFormHandler.initOnContainer(element);
    element.querySelectorAll('.quantity-input').forEach(function (element) {
      if (!(element instanceof HTMLInputElement)) return console.error("WpOrder: quantity-input not instance of HTMLInputElement");
      WpFormHandler.validateNumericTextInputEvListener(element);
    });
  });
  document.querySelectorAll('.order-form-wrapper-overview').forEach(function (element) {
    WpOrderUtils._updateSubmitBtnPriceOverview(element);
  });
});
// @ts-check

window.addEventListener("load", function () {
  var target = document.querySelectorAll(".zamg-js-target");
  if (target.length == 0) return;

  /*
      ? call the update img ajax and reload the image
  */

  fetch('?type=916104').then(function (response) {
    if (response.ok) return response.json();
    throw new Error("Network response was not ok.");
  }).then(function (res) {
    target.forEach(function (target) {
      if (target instanceof HTMLImageElement) {
        var _target$parentElement;
        target.src = res.fullPath;
        var container = (_target$parentElement = target.parentElement) === null || _target$parentElement === void 0 ? void 0 : _target$parentElement.parentElement;
        if (container) {
          /** @type {HTMLElement|null} */
          var spinner = container.querySelector(".loading-spinner");
          spinner === null || spinner === void 0 || spinner.style.setProperty("opacity", "0");
          setTimeout(function () {
            return spinner === null || spinner === void 0 ? void 0 : spinner.remove();
          }, 1000);

          /** @type {HTMLElement|null} */
          var placeholder = container.querySelector(".zamg-js-target-placeholder");
          placeholder === null || placeholder === void 0 || placeholder.style.setProperty("opacity", "0");
          setTimeout(function () {
            return placeholder === null || placeholder === void 0 ? void 0 : placeholder.remove();
          }, 1000);
        }
      }
    });
  });
});
// @ts-check
var FormHandler = /*#__PURE__*/function () {
  function FormHandler() {
    _classCallCheck(this, FormHandler);
  }
  return _createClass(FormHandler, [{
    key: "initOnContainer",
    value:
    /**
     * initialize all listeners for the form and update initial state
     *
     * @param {Element} container
     */
    function initOnContainer(container) {
      var _this2 = this;
      container.querySelectorAll("[name=g-recaptcha-response]").forEach(function (element) {
        if (element instanceof HTMLTextAreaElement) {
          element.required = true;
        }
        setInterval(function () {
          element.dispatchEvent(new Event("change"));
        }, 1000);
      });

      /* set php form validation errors as html5 validation errors */
      this.checkValidationResults(container);

      /* set option "null" to empty string */
      container.querySelectorAll("option").forEach(function (option) {
        if (option.value == "null") option.value = "";
      });
      container.querySelectorAll(".switch .slider").forEach(function (checkboxControl) {
        checkboxControl.addEventListener('click', function () {
          var _checkboxControl$pare;
          var label = (_checkboxControl$pare = checkboxControl.parentElement) === null || _checkboxControl$pare === void 0 || (_checkboxControl$pare = _checkboxControl$pare.parentElement) === null || _checkboxControl$pare === void 0 ? void 0 : _checkboxControl$pare.querySelector("label");
          label === null || label === void 0 || label.click();
        });
      });

      /* add event listeners */
      container.querySelectorAll("input").forEach(function (input) {
        _this2.validityListeners(input);
        if (["text", "number", "email", 'tel'].includes(input.type)) {
          _this2.labelAnimationListeners(input);
        }
        if (input.type == "checkbox") {
          _this2.checkboxListeners(input, container);
        }
        if (input.type == "radio") {
          input.addEventListener("click", function (_event) {
            document.querySelectorAll("input[name=\"".concat(input.name, "\"][type=\"radio\"]")).forEach(function (radio) {
              radio.dispatchEvent(new Event("change"));
            });
          });
        }
      });
      container.querySelectorAll("textarea").forEach(function (input) {
        _this2.validityListeners(input);
        _this2.labelAnimationListeners(input);
      });
      container.querySelectorAll("select").forEach(function (select) {
        _this2.validityListeners(select);
      });

      /* trigger events for label / checkbox content */
      container.querySelectorAll("input, select, textarea").forEach(function (input) {
        setTimeout(function () {
          if (input instanceof HTMLInputElement && input.type == "checkbox") {
            var _input$parentNode;
            if (!input.checked) return;
            (_input$parentNode = input.parentNode) === null || _input$parentNode === void 0 || (_input$parentNode = _input$parentNode.parentNode) === null || _input$parentNode === void 0 || _input$parentNode.querySelectorAll(".toggle-text").forEach(function (toggle) {
              toggle.classList.add("active");
            });
          }
          input.dispatchEvent(new Event("change"));
          input.dispatchEvent(new Event("focusin"));
          input.dispatchEvent(new Event("blur"));
        }, 10);
        setTimeout(function () {
          /* duplicate of labelAnimationListeners => bugfix for loading state */
          if (input instanceof HTMLInputElement) {
            var _input$parentNode2;
            (_input$parentNode2 = input.parentNode) === null || _input$parentNode2 === void 0 || _input$parentNode2.querySelectorAll("label").forEach(function (label) {
              label.classList.add("animated-label-up");
              if (input.value.length == 0 && input.type != "date" && input.type != "hidden" && !input.validity.badInput) {
                setTimeout(function () {
                  return label.classList.remove("animated-label-up");
                }, 10);
              }
            });
          }
        }, 100);
      });

      /* update required fields for hidden content */
      setTimeout(function () {
        return _this2.updateRequiredFields(document.querySelectorAll('.d-none'), false);
      }, 10);
      var form = container.querySelector("form");
      if (form instanceof HTMLFormElement) {
        /** @type {HTMLButtonElement|null} */
        var submitBtn = container.querySelector("button[type='submit']");
        if (submitBtn) {
          submitBtn.addEventListener("click", function (_event) {
            if (!form.checkValidity()) {
              // focus on first element
              var messageContainer = form.querySelector('[id^="errormessage"]');
              if (messageContainer instanceof HTMLElement) {
                messageContainer.innerText = "\xDCberpr\xFCfe das Formular. Es wurden nicht alle Felder richtig ausgef\xFCllt.";
                messageContainer.classList.remove("display-none");
                messageContainer.classList.add("alert-danger");
                messageContainer.classList.add("alert");
                messageContainer.scrollIntoView({
                  behavior: "smooth",
                  block: "center"
                });
              }
              var firstInput = form.querySelector('input:not([type="hidden"])');
              if (firstInput instanceof HTMLInputElement) {
                firstInput.focus();
              }
            }
            form.classList.add("was-validated");
          });
        } else {
          return console.error("FormHandler: submit button not found");
        }
        form.addEventListener('invalid', function (event) {
          event.preventDefault();
        }, true);
      }
    }

    /**
     * set php form validation errors as html5 validation errors
     * @param {Element} container
     */
  }, {
    key: "checkValidationResults",
    value: function checkValidationResults(container) {
      var validationErrors = container.querySelectorAll(".validationError");
      if (validationErrors.length > 0) {
        var form = container.querySelector("form");
        if (form instanceof HTMLFormElement) form.classList.add("was-validated");
      }
      validationErrors.forEach(function (errorElement) {
        var _errorElement$dataset;
        if (!(errorElement instanceof HTMLElement)) return;
        var path = (_errorElement$dataset = errorElement.dataset.path) === null || _errorElement$dataset === void 0 ? void 0 : _errorElement$dataset.split('.')[1];
        var errorMessages = errorElement.innerText.split("\n").filter(function (message) {
          return message.trim().length > 0;
        }).join("\n");
        if (path == undefined) return;
        if (path == "eMail") path = "e_mail";
        var input = container.querySelector('#' + path);
        if (input instanceof HTMLInputElement) input.setCustomValidity(errorMessages.trim());
      });
    }

    /**
     * update required fields when showing / hiding a container
     *
     * @param {HTMLInputElement|NodeList|HTMLSelectElement} target
     * @param {boolean} status
     */
  }, {
    key: "updateRequiredFields",
    value: function updateRequiredFields(target, status) {
      /**
       * @param {HTMLInputElement|HTMLSelectElement} input,
       * @param {boolean} status
       * */
      var updateInput = function updateInput(input, status) {
        if (status) {
          if (input.classList.contains("js-required")) input.required = true;
        } else if (input.required) {
          input.classList.add("js-required");
          input.required = false;
        }
      };
      if (target instanceof HTMLInputElement || target instanceof HTMLSelectElement) updateInput(target, status);
      if (target instanceof NodeList) {
        target.forEach(function (target) {
          if (!(target instanceof HTMLElement)) return console.error("FormHandler: target not found");
          target.querySelectorAll("input, select").forEach(function (input) {
            if (input instanceof HTMLInputElement || input instanceof HTMLSelectElement) updateInput(input, status);
          });
        });
      }
    }

    /**
     * label animation listeners, sets class animated-label-up
     * - on focusin
     * - on blur
     *
     * @param {HTMLTextAreaElement|HTMLInputElement} input
     */
  }, {
    key: "labelAnimationListeners",
    value: function labelAnimationListeners(input) {
      var fnLabelAnimationUp = function fnLabelAnimationUp() {
        var _input$parentNode3;
        (_input$parentNode3 = input.parentNode) === null || _input$parentNode3 === void 0 || _input$parentNode3.querySelectorAll("label").forEach(function (label) {
          label.classList.add("animated-label-up");
        });
      };
      var fnLabelAnimation = function fnLabelAnimation() {
        var _input$parentNode4;
        (_input$parentNode4 = input.parentNode) === null || _input$parentNode4 === void 0 || _input$parentNode4.querySelectorAll("label").forEach(function (label) {
          if (input.value.length != 0) return;
          if (input.validity.badInput) return;
          if (input.type == "date") return;
          label.classList.remove("animated-label-up");
        });
      };
      input.addEventListener("focusin", function (_event) {
        fnLabelAnimationUp();
      });
      input.addEventListener("blur", function (_event) {
        fnLabelAnimation();
      });
      input.addEventListener("onautocomplete", function (_event) {
        fnLabelAnimationUp();
      });
    }

    /**
     * checkbox listeners for showing / hiding containers
     * values for selectors are stored in the data attributes
     * - dataset.showonactive
     * - dataset.showoninactive
     *
     * @param {HTMLInputElement} input
     * @param {Element} container
     */
  }, {
    key: "checkboxListeners",
    value: function checkboxListeners(input, container) {
      var _this3 = this;
      input.addEventListener("change", function (_event) {
        var _input$parentNode5;
        var wrapContainer = (_input$parentNode5 = input.parentNode) === null || _input$parentNode5 === void 0 ? void 0 : _input$parentNode5.parentNode;
        if (wrapContainer && wrapContainer instanceof HTMLElement && wrapContainer.classList.contains("fieldwrap")) {
          wrapContainer.querySelectorAll(".toggle-text").forEach(function (toggle) {
            if (input.checked) return toggle.classList.add("active");
            toggle.classList.remove("active");
          });
        }
        if (input.dataset.showonactive) {
          var dataTarget = container.querySelectorAll(input.dataset.showonactive);
          _this3.updateRequiredFields(dataTarget, input.checked);
          dataTarget.forEach(function (target) {
            target.classList.add("d-none");
          });
          if (input.checked) dataTarget.forEach(function (target) {
            target.classList.remove("d-none");
            target.querySelectorAll('input[type="checkbox"]').forEach(function (checkbox) {
              checkbox.dispatchEvent(new Event("change"));
            });
          });
        }
        if (input.dataset.showoninactive) {
          var _dataTarget = container.querySelectorAll(input.dataset.showoninactive);
          _this3.updateRequiredFields(_dataTarget, !input.checked);
          _dataTarget.forEach(function (target) {
            target.classList.add("d-none");
          });
          if (!input.checked) _dataTarget.forEach(function (target) {
            target.classList.remove("d-none");
            target.querySelectorAll('input[type="checkbox"]').forEach(function (checkbox) {
              checkbox.dispatchEvent(new Event("change"));
            });
          });
        }
      });
    }

    /**
     * add html validation errors as text to the container (span.error)
     * - on invalid
     * - on keyup
     * - on change
     * check for these data attributes on the input and sets it on the container
     * - data-custom-error-message
     * - data-custom-error-class
     *
     * @param {HTMLTextAreaElement|HTMLInputElement|HTMLSelectElement} input
     */
  }, {
    key: "validityListeners",
    value: function validityListeners(input) {
      /**
       * @param {HTMLElement|null|undefined} container,
       * @param {HTMLTextAreaElement|HTMLTextAreaElement|HTMLInputElement|HTMLSelectElement} input,
       * @param {boolean} checkValidity
       * */
      var updateErrorState = function updateErrorState(container, input) {
        var _input$dataset, _input$dataset2;
        var checkValidity = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        if (!(container instanceof HTMLElement)) return console.error("FormHandler: container not found");
        if (checkValidity) input.checkValidity();
        var customErrorMessage = (_input$dataset = input.dataset) === null || _input$dataset === void 0 ? void 0 : _input$dataset.customErrorMessage;
        var customErrorClass = (_input$dataset2 = input.dataset) === null || _input$dataset2 === void 0 ? void 0 : _input$dataset2.customErrorClass;
        if (input.validationMessage) {
          container.classList.add("has-error");
        } else {
          container.classList.remove("has-error");
        }
        var errorElement = container.querySelector('.error');
        if (!(errorElement instanceof HTMLElement)) {
          var newElement = document.createElement("span");
          newElement.classList.add("error");
          newElement.setAttribute("id", "error" + input.id);
          container.insertAdjacentElement("beforeend", newElement);
          errorElement = container.querySelector('.error');
        }
        if (errorElement instanceof HTMLElement) {
          var _errorElement;
          if (customErrorClass) (_errorElement = errorElement) === null || _errorElement === void 0 || _errorElement.classList.add(customErrorClass);
          if (customErrorMessage) return errorElement.innerText = customErrorMessage;
          errorElement.innerText = input.validationMessage;
        }
      };
      if (input instanceof HTMLInputElement || input instanceof HTMLSelectElement || input instanceof HTMLTextAreaElement) {
        /** @type {HTMLElement|null|undefined} */
        var parent = input.parentElement;
        if (!parent) return;

        // check if input is type of checkbox
        if (input.type === "checkbox") {
          var _input$parentElement;
          parent = (_input$parentElement = input.parentElement) === null || _input$parentElement === void 0 || (_input$parentElement = _input$parentElement.parentElement) === null || _input$parentElement === void 0 ? void 0 : _input$parentElement.parentElement;
        }

        // radios of a group share a single error message -> attach it to
        // the wrapper around the radiogroup instead of each option label,
        // so the error is rendered only once per group (not per radio).
        if (input.type === "radio") {
          var _input$closest$parent, _input$closest;
          parent = (_input$closest$parent = (_input$closest = input.closest('[role="radiogroup"]')) === null || _input$closest === void 0 ? void 0 : _input$closest.parentElement) !== null && _input$closest$parent !== void 0 ? _input$closest$parent : input.parentElement;
        }
        if (!parent) return;
        input.addEventListener("invalid", function (_event) {
          return updateErrorState(parent, input);
        });
        input.addEventListener("keyup", function (_event) {
          return updateErrorState(parent, input, true);
        });
        input.addEventListener("change", function (_event) {
          return updateErrorState(parent, input, true);
        });
      }
    }

    /**
     * sort options of a select element alphabetically
     * replaces special characters: Ä, Ö, Ü, ß
     *
     * @param select {HTMLSelectElement}
     */
  }, {
    key: "sortSelectOptions",
    value: function sortSelectOptions(select) {
      if (!select.options) return;
      var options = Array.from(select.options);

      /**
       * @param {string} text
       * @return {string}
       */
      var parseText = function parseText(text) {
        text = text.toUpperCase();
        text = text.replace(/Ä/g, 'AE');
        text = text.replace(/Ö/g, 'OE');
        text = text.replace(/Ü/g, 'UE');
        text = text.replace(/ß/g, 'SS');
        text = text.replace(/Å/g, 'AA');
        return text;
      };
      options.sort(function (a, b) {
        var textA = parseText(a.text);
        var textB = parseText(b.text);
        if (a.value === "") return -1;
        if (a.value === "") return 1;
        return textA < textB ? -1 : textA > textB ? 1 : 0;
      });
      select.innerHTML = '';
      options.forEach(function (option) {
        return select.add(option);
      });
    }

    /**
     * validate: <input type="text" inputmode="numeric">
     * - on keyup
     * option to allow negative numbers (default: false)
     * input only allows int values
     * validation:
     * - set value to 0 if empty str
     * - remove leading 0
     * - stripe non number chars
     *
     * @param {HTMLInputElement} inputElement
     * @param {boolean} allowNegative
     */
  }, {
    key: "validateNumericTextInputEvListener",
    value: function validateNumericTextInputEvListener(inputElement) {
      var allowNegative = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      inputElement.dispatchEvent(new Event("keyup"));
      inputElement.addEventListener("keyup", function () {
        var _strStartsWithMinus = inputElement.value.startsWith("-");

        // strip non int chars
        var currentValueStr = inputElement.value.replace(/[^0-9]/g, '');
        var newValueStr = currentValueStr;

        // set 0 if empty or invalid
        var _isEmptyStr = currentValueStr == "";
        var _isNegativeInt = parseInt(currentValueStr) < 0;
        var _isNanStr = currentValueStr == "NaN";
        if (_isEmptyStr || _isNanStr || _isNegativeInt && !allowNegative) newValueStr = "0";

        // add minus if needed
        if (_strStartsWithMinus && allowNegative) newValueStr = "-" + newValueStr;

        // removed leading 0
        newValueStr = parseInt(newValueStr).toString();

        // set new value
        if (inputElement.value != newValueStr) inputElement.value = newValueStr;
      });
    }
  }]);
}();
globalThis.WpFormHandler = new FormHandler();